module.exports = __webpack_public_path__ + "static/coran-131b873be9e5a3ed23df79cc037fc556.jpg";